"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toFlaggedTransactionStatus = exports.validateForCreate = exports.matchTransactionToParams = exports.FlaggedTransactionStatuses = exports.FlaggedTransactionTypes = void 0;
const commonUtil = __importStar(require("./commonUtil"));
const Errors_1 = require("./Errors");
const commonUtil_1 = require("./commonUtil");
const Links_1 = require("./Links");
const AskRequests_1 = require("./AskRequests");
exports.FlaggedTransactionTypes = {
    Ask_Customer: "Ask Customer",
    Ask_Bookkeeper: "Ask Bookkeeper"
};
exports.FlaggedTransactionStatuses = {
    Open: "Open",
    In_Progress: "In Progress",
    Closed: "Closed"
};
function matchTransactionToParams(t, params) {
    return t.externalTransactionType === params.externalTransactionType &&
        t.externalId === params.externalId &&
        commonUtil.toShortString(t.date) === params.date &&
        commonUtil.areEquivalentNumbers(t.amount, params.amount) &&
        (!params.externalNum || t.externalNum === params.externalNum) &&
        (!params.name || t.name === params.name) &&
        (!params.memo || t.memo === params.memo);
}
exports.matchTransactionToParams = matchTransactionToParams;
function validateForCreate(toValidate, throwException = false) {
    if (!toValidate || !toValidate.date ||
        !toValidate.externalTransactionType || !toValidate.externalId || !(0, commonUtil_1.isValidNumber)(toValidate.amount)) {
        return (0, Errors_1.falseOrThrow)(throwException, Errors_1.FlaggedTransactionErrors.invalidRequest);
    }
    // Check reportType
    const reportType = toValidate.reportType;
    if (reportType && !(0, Links_1.isReportType)(reportType)) {
        return (0, Errors_1.falseOrThrow)(throwException, () => Errors_1.FlaggedTransactionErrors.invalidReportType(reportType));
    }
    return true;
}
exports.validateForCreate = validateForCreate;
function toFlaggedTransactionStatus(status) {
    if (!status) {
        return status;
    }
    switch (status) {
        case AskRequests_1.AskRequestStatuses.Closed:
            return exports.FlaggedTransactionStatuses.Closed;
        case AskRequests_1.AskRequestStatuses.In_Progress:
            return exports.FlaggedTransactionStatuses.In_Progress;
        case AskRequests_1.AskRequestStatuses.Open:
            return exports.FlaggedTransactionStatuses.Open;
    }
    return undefined;
}
exports.toFlaggedTransactionStatus = toFlaggedTransactionStatus;
//# sourceMappingURL=Transactions.js.map